// A style's text and sidebar colors, the same for every style but for the brand's color. The
// section colors and the designer note keep their own. A style's images live in styles.scss
// and src/assets (aa-design-2, the AcroDance Pre School look, differs from aa-design-1 only there).
function brandDesign(color: string) {
  const text = (font: string, fontSize: number, lineHeight: number, align: string) => ({
    color: color,
    font: font,
    fontSize: fontSize,
    lineHeight: lineHeight,
    align: align,
  });
  return {
    "text-title": text("Gotham-Black", 34, 41, "center"),
    "text-subtitle": text("Gotham-Medium", 22, 30, "center"),
    "text-normal": text("Gotham-Medium", 15, 20, "left"),
    "text-normal-sm": text("Gotham-Medium", 13, 22, "left"),
    "text-normal-lg": text("Gotham-Medium", 18, 25, "left"),
    "text-normal-center": text("Gotham-Medium", 15, 20, "center"),
    "text-normal-sm-center": text("Gotham-Medium", 13, 22, "center"),
    "text-normal-lg-center": text("Gotham-Medium", 18, 25, "center"),
    "designer-note": {
      color: "red",
      font: "Gotham-MediumItalic",
      fontSize: 18,
      lineHeight: 25,
      align: "left",
    },
    "color-title": {
      bg: "#A5C5CE",
      color: "#FFF",
    },
    "color-technique": {
      bg: "#26C21D",
      color: "#FFF",
    },
    "color-variation": {
      bg: "#DE1C13",
      color: "#FFF",
    },
    "color-pac": {
      bg: "#EB8700",
      color: "#FFF",
    },
    "color-exam": {
      bg: "#7B3DDA",
      color: "#FFF",
    },
    "color-default": {
      bg: "transparent",
      color: color,
    },
  };
}

export class Config {
  static SERVER_API: string = "/api/";
  static SERVER_API_UPLOAD: string = "/api/upload";
  static SERVER_UPLOADFOLDER: string = "";
  static APP_NAME: string = "Online Study";
  static ADMIN_FROM_BACKOFFICE: string = "Open the online study again from the backoffice.";
  static ADMIN_SESSION_ENDED: string =
    "Your session has ended, so nothing was saved. Log in, then press the button again. Your work is still on the page.";
  static ADMIN_SESSION_ENDED_AUTOSAVE: string =
    "Your session has ended, so the grading was not saved. Log in, and it will be saved.";

  static STYLE = {
    "aa-design-1": brandDesign("#2261bf"),
    "aa-design-2": brandDesign("#2261bf"),
    "aerial-design-1": brandDesign("#7a4a9c"),
    "baton-design-1": brandDesign("#cc0000"),
    "tap-design-1": brandDesign("#21833a"),
  };

  // The brand this host serves, set by BrandService before the app starts. The look follows
  // it, never an admin's choice.
  static BRAND: string = "acro";

  // The styles each brand offers; the first one is the brand's standard style.
  static BRANDS: { [brand: string]: { styles: { id: string; name: string }[] } } = {
    acro: {
      styles: [
        { id: "aa-design-1", name: "Acrobatic Arts" },
        { id: "aa-design-2", name: "AcroDance Pre School" },
      ],
    },
    aerial: { styles: [{ id: "aerial-design-1", name: "Aerial Arts" }] },
    baton: { styles: [{ id: "baton-design-1", name: "Baton Arts" }] },
    tap: { styles: [{ id: "tap-design-1", name: "Tap Roots" }] },
  };

  // The style an exam is shown in: its own when the brand offers it, else the brand's
  // standard. Stored exams are never rewritten; a save stores what was shown.
  static EffectiveStyle(style: string): string {
    const styles = Config.BRANDS[Config.BRAND].styles;
    for (const s of styles) {
      if (s.id == style) {
        return style;
      }
    }
    return styles[0].id;
  }
}
